import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TickerBar from "@/components/TickerBar";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Exposed from "@/components/Exposed";
import NewsletterContact from "@/components/NewsletterContact";
import TrademarkMarquee from "@/components/TrademarkMarquee";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  const k = "hra_session_id";
  let v = localStorage.getItem(k);
  if (!v) {
    v = "s-" + Math.random().toString(36).slice(2, 10) + "-" + Date.now().toString(36);
    localStorage.setItem(k, v);
  }
  return v;
}

function Landing() {
  useEffect(() => {
    // Hidden message — visible only to those inspecting the console.
    if (typeof console !== "undefined" && !window.__HRA_SEAL_PRINTED__) {
      window.__HRA_SEAL_PRINTED__ = true;
      console.log(
        "%c\n  ─────────────────────────────────────────────────────────\n" +
          "   TO WHOEVER IS INSPECTING THIS SITE:\n\n" +
          "   Blessed by YHWH and sealed by the Blood of Jesus Christ,\n" +
          "   Yeshua Hamashiach.\n\n" +
          "                                — Romona Nicole Schmidt\n" +
          "  ─────────────────────────────────────────────────────────\n",
        "color:#E02424;font-family:monospace;font-size:12px;line-height:1.5;",
      );
    }

    // Fire a pageview ping (fire-and-forget; safe if it fails).
    if (!window.__HRA_PV_SENT__) {
      window.__HRA_PV_SENT__ = true;
      axios
        .post(`${API}/track/pageview`, {
          path: window.location.pathname + window.location.hash,
          referrer: document.referrer || null,
          session_id: getSessionId(),
        })
        .catch(() => {});
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App min-h-screen bg-[#050505] text-white" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <TickerBar />
        <Manifesto />
        <Services />
        <Exposed />
        <NewsletterContact />
        <TrademarkMarquee />
      </main>
      <Footer />
      <Chatbot />
      <Toaster theme="dark" position="bottom-left" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
